import React from 'react';
import { Webform } from '@uncinc/react-drupal-core';
import WebformHousingPriceCalculator from '../../../components/WebformHousingPriceCalculator';

import './style.scss';

const ParagraphWebform = ({ entity }) => {
  const id = entity.getIn(['field_webform', 0, 'target_id']);
  const status = entity.getIn(['field_webform', 0, 'status']);
  const isHousingPriceCalculator = id === 'rekentool';


  return (
    <div className="Paragraph ParagraphWebform" id={`webform_${id}`}>
      {isHousingPriceCalculator ? (
        <WebformHousingPriceCalculator
          entity={entity}
        />
      ) : (
        <Webform
          id={id}
          status={status}
        />
      )}
    </div>
  );
};

export default ParagraphWebform;
